// extracted by mini-css-extract-plugin
export var headerCell = "_1e-1";
export var loadingStateCell = "_1e-4";
export var rowWrapper = "_1e-3";
export var standaloneTable = "_1e-5";
export var table = "_1e-0";
export var white = "_1e-2";